export const routes = (parentName) => {
  return [
    {
      path: "dictionary",
      component: () => import("./Index.vue"),
      children: [
        {
          path: "",
          name: `${parentName}-Dictionary`,
          component: () => import("./List.vue"),
          props: (route) => ({
            step: route.query.step,
          }),
        },
        {
          path: "cat",
          name: `${parentName}-Dictionary-Cat`,
          component: () => import("./ListCat.vue"),
          props: (route) => ({
            step: route.query.step,
          }),
        },
        {
          path: "new",
          name: `${parentName}-Dictionary-New`,
          component: () => import("./Upsert.vue"),
        },

        {
          path: "new-cat",
          name: `${parentName}-Dictionary-Cat-New`,
          component: () => import("./UpsertCat.vue"),
        },

        {
          path: ":id",
          name: parentName + "-" + "Dictionary-View",
          component: () => import("./View.vue"),
        },
        {
          path: ":id/edit",
          name: parentName + "-" + "Dictionary-Edit",
          component: () => import("./Upsert.vue"),
        },
      ],
    },
  ];
};
